import React from 'react';
import ViagemForm from '../../../components/ViagemForm';

const Forms = () => {
  return <ViagemForm />;
};

export default Forms;
